import { render, staticRenderFns } from "./AnswerMap.vue?vue&type=template&id=32655f32&scoped=true&"
import script from "./AnswerMap.vue?vue&type=script&lang=js&"
export * from "./AnswerMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32655f32",
  null
  
)

export default component.exports